import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { invoiceServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const invoiceInstance = axios.create({
  baseURL: invoiceServiceUrl,
  headers,
})

invoiceInstance.interceptors.request.use(config => {
  return requestInterceptor(config)
}, error => Promise.reject(error))

invoiceInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default invoiceInstance
